import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ntambakure from '../assets/images/bg.jpg';
import videoBg from '../assets/video/urabikoze.mp4';
import Footer from './Footer';
import ConcertSupportCard from './ConcertSupportCard';

// Helper function to truncate description
const truncateDescription = (description, wordLimit) => {
  const words = description.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return description;
};

// Card payment (Centiwise) is parked for now — no merchant agreement signed yet.
// Re-enable by restoring the "Donate Now" button, DonateModal, and the
// `import DonationForm from './DonationForm';` import.

const Donation = () => {
  const [donationActivities, setDonationActivities] = useState([]);

  useEffect(() => {
    const fetchDonations = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/post/all`);
        const data = await response.json();

        // Filter the activities to only include those with the category "Donation"
        const filteredDonations = data.filter(
          (activity) => activity.category === 'Donation'
        );

        // Map to the structure you want to use
        const formattedDonations = filteredDonations.map((activity) => ({
          id: activity.ID,
          title: activity.title,
          description: activity.description,
          imageUrl: `${process.env.REACT_APP_BASE_URL}${activity.image_video}`, // Use base URL from .env
          videoUrl: activity.image_video.endsWith('.mp4')
            ? `${process.env.REACT_APP_BASE_URL}${activity.image_video}`
            : '',
          raisedAmount: activity.amount,
          goalAmount: 100000, // Set a default goal or fetch it from the API if available
        }));

        setDonationActivities(formattedDonations);
      } catch (error) {
        console.error('Error fetching donations:', error);
      }
    };

    fetchDonations();
  }, []);

  return (
    <div className="bg-white dark:bg-black transition-colors duration-300">
      {/* Top Right Single Donation Button */}

      <div className="p-8 md:w-[1200px] pt-[150px] mx-auto text-center">
        <h2 className="text-center text-8xl font-glsnecb mb-8 text-gray-900 dark:text-white">Donation</h2>

        <div className="py-4 mb-8">
          <ConcertSupportCard subtitle="You can support the concert financially using any of the options below." />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {donationActivities.map((activity) => (
            <div key={activity.id} className="max-w-xs mx-auto mb-8 w-full">
              <div className="overflow-hidden rounded-lg shadow-lg border border-black">
                {activity.videoUrl ? (
                  <video className="w-full h-48 object-cover" controls>
                    <source src={activity.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={activity.imageUrl}
                    alt={activity.title}
                    className="w-full h-48 object-cover"
                  />
                )}
                <div className="p-4 text-white font-myraid bg-black">
                  <h3 className="font-bold text-lg mb-2">{activity.title}</h3>
                  <p className="text-[12px] mb-4">
                    {truncateDescription(activity.description, 30)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Donation;
